<template>
    <h1 class="SearchHeading">{{ searchStore.pageTitle }}</h1>
</template>


<script setup lang="ts">
import { useSearchStore } from '@app/stores/useSearchStore';
const searchStore = useSearchStore();
</script>

<style scoped lang="scss">
.SearchHeading {
    color: $Grey-900;

    @include TextStyle(HeadingSmall);

    @include Breakpoint(Medium, Large, ExtraLarge) {
        @include TextStyle(HeadingMedium);
    }
}
</style>